import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';

@Component({
  selector: 'app-feed-master-dialog',
  templateUrl: './feed-master-dialog.component.html',
  styleUrls: ['./feed-master-dialog.component.scss']
})
export class FeedMasterDialogComponent implements OnInit {
  public meisai: any = {};
  public shubetsu = '';
  title = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public commonService: CommonService,
              public matDialogRef: MatDialogRef<FeedMasterDialogComponent>,) { }

  /**
   *
   */
  ngOnInit(): void {
    this.meisai = this.data.meisai;
    if (!this.meisai?.id) {
      this.meisai.id = this.commonService.genUniqueStr();
    }
    this.shubetsu = this.data.shubetsu;
    this.title = '餌プログラム追加・修正';
  }
}
